<script>
  import BusinessCategoryItem from './BusinessCategoryItem';
  import { productListMethods, productListComputed, layoutMethods, erpUserRolesMethods  } from "@/state/helpers";
  import ImageUpload from '@/components/ImageUpload';

  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Business category component
   */
  export default {
    page: {
      title: "Business Category"
    },
    data() {
      return {
        title: "Business Category",
        folder: 'product-categories',
        businessLogo: {
          filename: null,
          type: null,
          base64: null
        },
        pagination: {
          rows: 12,
          page: 1
        },
        editModal: false,
        createModal: false,
        businessCategoryItem: {
          productId: null,
          productName: '',
          productImageSrc: ''
        },
        formExitChecker: {
          productId: null,
          productName: '',
          productImageSrc: ''
        },
        businessCategoryModule: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        } 
      };
    },
    components: { 
      BusinessCategoryItem,
      ImageUpload
    },
    computed: {
      ...productListComputed
    },
    methods: {
      ...layoutMethods,
      ...productListMethods,
      ...erpUserRolesMethods,
      refresh(){
        this.listBussCategories();
      },
      openCreateModal(){
        this.clearCategory();
        this.clearLogo();
        this.createModal = true;
      },
      listBussCategories(){
        this.listBusinessCategories(this.pagination);
      },
      createBussCategory(){
        var categoryObj = { ...this.businessCategoryItem };
        delete categoryObj.productId;
              
        if(this.businessLogo.base64){
          var businessLogo = { ...this.businessLogo };
          businessLogo.folder = this.folder;

          this.uploadLogo(businessLogo)
            .then((imageKey) => {
              categoryObj = { 
                ...categoryObj,
                productImageSrc: imageKey
              }
              
              this.create(categoryObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.create(categoryObj);
        }
      },
      editBussCategory(businessCategory){
        if (!this.businessCategoryModule.access.read &&  !this.businessCategoryModule.access.update) {
          Swal.fire(
            "Access Restricted",
            "Looks like your access is limited. Please contact your administrator.",
            "warning"
          );
        } else {
          console.log(businessCategory);
          this.editModal = true;
          this.businessCategoryItem = { 
            productId: businessCategory.productId,
            productName: businessCategory.productName,
            productImageSrc: businessCategory.productImageSrc
          }
          this.formExitChecker = { 
            productId: businessCategory.productId,
            productName: businessCategory.productName,
            productImageSrc: businessCategory.productImageSrc
          }
        }
      },
      saveBussCategory(){
        var categoryObj = { ...this.businessCategoryItem };
        delete categoryObj['productImageSrc'];

        if(this.businessLogo.base64){
          var businessLogo = { ...this.businessLogo };
          businessLogo.folder = this.folder;

          this.uploadLogo(businessLogo)
            .then((imageKey) => {
              categoryObj = { 
                ...categoryObj,
                productImageSrc: imageKey
              }
              this.update(categoryObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.update(categoryObj);
        }
      },
      deleteBussCategory(businessCategory){
        if (!this.businessCategoryModule.access.delete) {
          Swal.fire(
            "Access Restricted", 
            "You are not allowed to delete a Business Category.", 
            "warning");
        } else {
          if(businessCategory.itemCount > 0){
            Swal.fire("Deletion Not Allowed!",`${businessCategory.productName} is currently being used by some products. Deletion is not allowed.`, "error");
          } else {
            Swal.fire({
              title: "Are you sure?",
              text: `Do you really want to delete ${businessCategory.productName}? This process cannot be undone.`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes",
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.isConfirmed) {
                this.deleteBusinessCategory(businessCategory.productId)
                  .then(() => {
                    Swal.fire("Delete Successful!", `${businessCategory.productName} has been deleted.`, "success");
                    this.listBussCategories();
                  })
                  .catch((e) => {
                    Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                  });
              } else {
                return;
              }
            });
          }
        }
      },
      create(categoryObj){
        this.createBusinessCategory(categoryObj)
          .then(() => {
            this.createModal = false;
            Swal.fire("Create Successful!", `${categoryObj.productName} has been created.`, "success");
            this.listBussCategories();
            this.clearLogo();
          })
          .catch(() => {
            this.createModal = false;
            Swal.fire("Create Failed!",`${categoryObj.productName} was not created.`, "error");
            this.clearLogo();
          });
      },
      update(categoryObj){
        this.updateBusinessCategory(categoryObj)
          .then(() => {
            this.editModal = false;
            Swal.fire("Update Successful!", `${categoryObj.productName} has been updated.`, "success");
            this.listBussCategories();
            this.clearLogo();
          })
          .catch(() => {
            this.editModal = false;
            Swal.fire("Update Failed!",`${categoryObj.productName} was not updated.`, "error");
            this.clearLogo();
          });
      },
      clearLogo(){
        this.businessLogo = {
          filename: null,
          type: null,
          base64: null
        }
      },
      clearCategory(){
        this.businessCategoryItem = {
          productId: null,
          productName: '',
          productImageSrc: ''
        }
      },
      clearform(){
        this.businessCategoryItem= {
          productId: null,
          productName: '',
          productImageSrc: ''
        }
        this.formExitChecker= {
          productId: null,
          productName: '',
          productImageSrc: ''
        }
      },
      leaveform(modal = 'add'){
          console.log(this.businessCategoryItem,this.formExitChecker);
          if(JSON.stringify(this.businessCategoryItem) == JSON.stringify(this.formExitChecker)){
              if(modal == 'add'){
                  this.createModal = false;
              }else if(modal == 'edit'){
                  this.editModal = false;
              }
              this.clearform();
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  if(modal == 'add'){
                      this.createModal = false;
                  }else if(modal == 'edit'){
                      this.editModal = false;
                  }
                  this.clearform();
              }else{
                  return;
              }
          })
      }
    },
    async mounted(){
      this.listBussCategories();
      this.changeTitle({title: 'Business Category'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Business Category', to: { name: 'Business Category'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Business Category')
        .then((access) => this.businessCategoryModule.access = access);

    }
  }
    
</script>

<template>
  <div>
        <div class="row">
            <div class="col-lg-12">
              <div class="card">
                  <div class="card-body">
                      <div class="row mb-3">
                          <div class="col-md-4 col-sm-4">
                              <div class="my-2">
                                  <h5 class="card-title text-dark">
                                      <span class="fw-normal ms-lg-2"
                                      >{{categoryTotalRows}}</span
                                      > Record(s)
                                  </h5>
                              </div>
                          </div>
                          <!-- end col --> 
                          
                          <div class="col-md-8 col-sm-8"> 
                              <div class="d-flex justify-content-lg-end mb-lg-3">
                                  <template>
                                    <div class="me-2">
                                      <b-button v-if="businessCategoryModule.access.create" @click="$router.push( { path: 'category/add' } )" variant="primary"><i class="uil uil-plus me-1"></i> Add Business Category</b-button>
                                    </div>
                                  </template>

                                  <a class="btn btn-secondary"
                                    @click="refresh"
                                      ><feather
                                      type="refresh-ccw"
                                      size="16"
                                      class="icon nav-icon"
                                      ></feather
                                      >&nbsp;&nbsp; Refresh</a
                                  >
                              </div>
                          </div>
                          <!-- end col -->
                      </div>
                      <!-- end row -->

                      <!-- grid list business category -->
                      <template>
                        <div class="row">
                          <business-category-item
                            v-for="(businessCategory, index) in businessCategories" 
                            v-bind:key="index"
                            v-bind:businessCategory="businessCategory"
                            @edit="$router.push( { path: `category/edit/${businessCategory.productId}` })"
                            @delete="deleteBussCategory(businessCategory)"
                            />
                        </div>
                        <!-- end row -->
                      </template>
                      <!-- end grid list business category -->

                      <div class="row g-0 text-center" v-if="categoryTotalRows == 0">
                        <span>No data to display.</span>
                      </div>
                      <div class="row g-0 text-center text-sm-start mt-3" v-if="categoryTotalRows != 0 && categoryTotalRows > 12">
                        <!-- end col -->
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="col">
                              <div class="dataTables_paginate paging_simple_numbers float-end">
                                <!-- pagination -->
                                <b-pagination
                                  class="pagination-rounded"
                                  v-model="pagination.page"
                                  @input="listBussCategories"
                                  :total-rows="categoryTotalRows"
                                  :per-page="pagination.rows"
                                ></b-pagination>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end col -->
                      </div>

                  </div>
                  <!-- end card body -->
              </div>
              <!-- end card -->
            </div>
            <!-- end col -->
        </div>

        <!-- all modal -->
        <!-- create modal -->
        <b-modal
          id="modalAddBusinessCategory"
          title="Add Business Category"
          size="md"
          centered
          hide-footer
          hide-header-close
          v-model="createModal"
        >
          <form class="px-4 py-3">
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label small fw-bold">Business Category</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Business Category"
                  v-model="businessCategoryItem.productName"
                />
              </div>
              <div class="cold-md-12 mb-3">
                <image-upload v-model="businessLogo" label="Category Image" :isRequired="true" />
              </div>
            </div>


            <div class="text-end mt-3">
              <b-button
                variant="light"
                class="w-sm"
                type="button"
                @click="leaveform()"
                >Close</b-button
              >
              <b-button 
                variant="primary" 
                class="w-sm ms-2"
                type="button"
                @click="createBussCategory()"
                >Save</b-button
              >
            </div>

          </form>
        </b-modal>
        <!-- end create modal -->
        <!-- edit modal -->
        <b-modal
          id="modalEditBusinessCategory"
          title="Edit Business Category"
          size="md"
          centered
          hide-footer
          hide-header-close
          v-model="editModal"
          >
            <form class="px-4 py-3">
                <div class="row">
                  <label v-if="!businessCategoryModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Business Category.</label>
                    <div class="col-md-12 mb-3">
                        <label class="form-label small fw-bold">Business Category</label>
                        <b-form-input
                          type="text"
                          class="form-control"
                          v-model="businessCategoryItem.productName"
                        />
                    </div>
                    <div class="cold-md-12 mb-3">
                      <image-upload v-model="businessLogo" :imageSrc="businessCategoryItem.productImageSrc" label="Category Image" :isRequired="true" />
                    </div>
                </div>

                <div class="text-end mt-3">
                    <b-button
                      variant="light"
                      class="w-sm"
                      type="button"
                      @click="() => leaveform('edit')"
                      >Close</b-button
                    >
                    <b-button 
                      :disabled="!businessCategoryModule.access.update"
                      variant="primary" 
                      class="w-sm ms-2"
                      type="button"
                      @click="saveBussCategory"
                      >Save</b-button
                    >
                </div>
            </form>
        </b-modal>
        <!-- end edit modal -->
  </div>
</template>